import React, { useContext, useEffect } from 'react';
import Link from 'next/link';
import { PropTypes } from 'prop-types';
import { i18n as I18n } from 'utils/i18n';

import { SearchContext } from '../../state/search';

// containers
import QuickSearch from '../../containers/quickSearch/index.tsx';

const LandingPage = ({
  heading,
  subHeading,
  roomType,
  pathname,
  locationPlaceholder,
}) => {
  const {
    actions: { onClearRoomTypes, updateRoomTypes },
  } = useContext(SearchContext);

  useEffect(() => {
    onClearRoomTypes([]);
    updateRoomTypes([roomType]);
  }, [onClearRoomTypes, updateRoomTypes, roomType]);

  return (
    <>
      <div className="banner__content banner--no-bottom-margin">
        <h1 className="banner__heading">{heading}</h1>
        <h2 className="banner__intro">{subHeading}</h2>
      </div>

      <QuickSearch
        showRoomTypes={false}
        locationPlaceholder={locationPlaceholder}
      />
      <Link
        href="#alternative-room-types"
        to={{
          pathname: { pathname },
          hash: '#alternative-room-types',
        }}
      >
        <a href="" id="room-types-link">
          {I18n.t('shared.alternative_room_types')}
        </a>
      </Link>
    </>
  );
};

LandingPage.propTypes = {
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  roomType: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  locationPlaceholder: PropTypes.string.isRequired,
};

export default LandingPage;
